import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import DashBoard from './renderer/pages/DashBoard/DashBoard-Page';
import SideBar from './renderer/components/SideBar/SibeBar';
import ClientesPage from './renderer/pages/Clientes/Clientes-Page';
import ProdutosPage from './renderer/pages/Produtos/Produtos-Page';
import FuncionariosPage from './renderer/pages/Funcionarios/Funcionarios-Page';
import ServicosPage from './renderer/pages/Servicos/Servicos-Page';
import VendasPage from './renderer/pages/Vendas/Vendas-Page';
import ComissoesPage from './renderer/pages/Comissoes/Comissoes-Page';
import CaixaPage from './renderer/pages/Caixa/Caixa-Page';
import ConfiguracoesPage from './renderer/pages/Configuracoes/Configuracoes-Page';

export default function AppRouter() {
  return (
    <HashRouter>
      <Routes>
        {/* Rotas com barra lateral */}
        <Route element={<SideBar />}>
          <Route path="/" element={<DashBoard />} />
          <Route path="/clientes" element={<ClientesPage />} />
          <Route path="/funcionarios" element={<FuncionariosPage />} />
          <Route path="/produtos" element={<ProdutosPage />} />
          <Route path="/servicos" element={<ServicosPage />} />
          <Route path="/vendas" element={<VendasPage />} />
          <Route path="/caixa" element={<CaixaPage />} />
          <Route path="/comissoes" element={<ComissoesPage />} />
          <Route path="/configuracoes" element={<ConfiguracoesPage />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}